import { createApp } from 'vue'
import store from 'store'

import ProductInfoTablist from './ProductInfoTablist.vue'

const el = '.nti-component--product-info-tablist'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        const app = createApp(ProductInfoTablist)
        app.use(store)
        app.mount(el)
    }
}

export default {
    render
}